export default class FlightTransfer {
  constructor() {
    this.airport_code = "";
    this.airport_name = null;
    this.time = "";
    this.city_name = "";
  }
}
